import React from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useScale } from "../../ScaleContext";

// Create a styled TextField that accepts a 'scale' prop
const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== "scale",
})(({ theme, scale }) => ({
  // Overall margin between text fields
  margin: scale > 1 ? theme.spacing(1.5, 0) : theme.spacing(2, 0),

  // Label styles
  "& label": {
    color: theme.palette.silverShades.light,
    fontSize: scale > 1 ? "0.8rem" : "1rem", // Adjust font size based on scale
    transform: scale > 1 ? "translate(5px, -18px) scale(1)" : "translate(5px, -20px) scale(1)",
    fontWeight: 200,
  },
  "& input": {
    color: "rgba(255,255,255,1)", //theme.palette.silverShades.light,
  },
  "& label.Mui-focused": {
    color: theme.palette.silverShades.light,
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: "rgba(0,0,0,0.25)", //theme.palette.blackShades.medium,
    padding: 0,
    "& fieldset": {
      borderColor: theme.palette.blackShades.medium,
      padding: "0 8px", // Reduce fieldset padding
    },

    "&:hover fieldset": {
      borderColor: theme.palette.blackShades.dark, //textbox border
      backgroundColor: "rgba(0,0,0,0.45)",
      color: "rgba(255,255,255,1)", //theme.palette.silverShades.light,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.blackShades.black, //textbox border
      color: "rgba(255,255,255,1)", //theme.palette.silverShades.light,
    },
    "& .MuiOutlinedInput-input": {
      padding: scale > 1 ? "4px 8px" : "8px 16px", // Adjust padding based on scale
      boxSizing: "border-box",
      lineHeight: 1.2,
      fontSize: scale > 1 ? "0.8rem" : "1rem",
      minHeight: scale > 1 ? "24px" : "32px", // Adjust height if necessary
      color: "rgba(255,255,255,1)", //theme.palette.silverShades.light,
    },
  },

  "& .MuiInputAdornment-root": {
    margin: 0,
    "& > *": {
      padding: 0,
    },
  },

  // Autofill styles
  "& input:-webkit-autofill": {
    backgroundColor: "rgba(255, 255, 255, 0.1) !important",
    color: theme.palette.silverShades.light,
    "-webkit-text-fill-color": theme.palette.silverShades.light,
    transition: "background-color 5000s ease-in-out 0s",
  },
}));

const CustomTextField = (props) => {
  const scale = useScale();
  const { inputProps, ...other } = props;
  return (
    <StyledTextField
      scale={scale}
      {...other}
      autoComplete="off"
      inputProps={{
        ...inputProps,
        autoComplete: "disable-autofill",
      }}
    />
  );
};

export default CustomTextField;

